import { UsersTable } from "@/components/admin/UsersTable";

export function SettingsUsersPage() {
  return <UsersTable />;
}
